import axios from 'axios'
import { API_URL } from '@/const'
import { store } from '@/store'

export const pathAxiosShowMsg = async (channel, id) => {
  const { accessToken } = store.state.app.user
  const headers = {
    Authorization: `Bearer ${accessToken}`
  }
  try {
    const { data } = await axios.patch(`${API_URL.MESSAGES}/${channel}/${id}`, {}, { headers })
    return data
  } catch (e) {
    console.log(e.response.data)

    return {}
  }
}
